/* =========================================
   Decision data & deck builder
   Extracted from Phaser CityScene
========================================= */

export const GENERIC_DECISIONS = [
  { text: 'Seu vereador precisa de apoio para aprovar\num projeto de lei na câmara. Como agir?', options: [
    { label: 'Articular votos com transparência', pop: 8, influence: 12, money: -20, risk: -5 },
    { label: 'Pressionar vereadores com dossiês', pop: -5, influence: 15, money: 0, risk: 15 },
    { label: 'Comprar apoio com emendas fantasma', pop: -10, influence: 10, money: -80, risk: 25 },
  ]},
  { text: 'Um empresário quer uma reunião privada\ncom seu vereador. O que você faz?', options: [
    { label: 'Agendar reunião oficial e transparente', pop: 5, influence: 5, money: 0, risk: -5 },
    { label: 'Cobrar taxa de intermediação', pop: -3, influence: 8, money: 60, risk: 15 },
    { label: 'Organizar jantar privado e pedir doação', pop: -8, influence: 12, money: 120, risk: 20 },
  ]},
  { text: 'A imprensa liga perguntando sobre gastos\nsuspeitos do gabinete. Como responder?', options: [
    { label: 'Prestar contas completas', pop: 10, influence: 3, money: -10, risk: -15 },
    { label: 'Dar respostas vagas e mudar de assunto', pop: -5, influence: 0, money: 0, risk: 5 },
    { label: 'Ameaçar processar o jornalista', pop: -12, influence: 5, money: -30, risk: 10 },
  ]},
  { text: 'Um lobista oferece uma "consultoria"\nno seu nome em troca de acesso político.', options: [
    { label: 'Recusar e denunciar ao partido', pop: 8, influence: -3, money: 0, risk: -10 },
    { label: 'Aceitar discretamente', pop: -2, influence: 5, money: 100, risk: 18 },
    { label: 'Negociar um valor maior', pop: -8, influence: 8, money: 200, risk: 25 },
  ]},
  { text: 'Uma associação de moradores pede ajuda\ncom um problema urgente no bairro.', options: [
    { label: 'Ir pessoalmente e mobilizar a câmara', pop: 15, influence: 5, money: -30, risk: -3 },
    { label: 'Encaminhar via ofício burocrático', pop: 3, influence: 0, money: 0, risk: 0 },
    { label: 'Usar o caso para autopromoção nas redes', pop: 10, influence: 3, money: -15, risk: 5 },
  ]},
  { text: 'O partido organiza um evento de arrecadação.\nComo você participa?', options: [
    { label: 'Organizar e convidar lideranças', pop: 5, influence: 12, money: -40, risk: -3 },
    { label: 'Ir como convidado apenas', pop: 2, influence: 3, money: -10, risk: 0 },
    { label: 'Desviar parte da arrecadação', pop: -5, influence: 5, money: 80, risk: 20 },
  ]},
  { text: 'Um assessor de outro político propõe\ntroca de favores e informações.', options: [
    { label: 'Aceitar aliança formal e pública', pop: 3, influence: 10, money: 0, risk: -3 },
    { label: 'Trocar informações sigilosas', pop: -5, influence: 15, money: 20, risk: 15 },
    { label: 'Recusar — independência acima de tudo', pop: 5, influence: -5, money: 0, risk: -5 },
  ]},
  { text: 'Há uma vaga em comissão na câmara.\nSeu vereador pode indicar alguém.', options: [
    { label: 'Indicar profissional qualificado', pop: 8, influence: 5, money: 0, risk: -5 },
    { label: 'Se auto-indicar para a posição', pop: -3, influence: 10, money: 40, risk: 8 },
    { label: 'Vender a indicação para interessados', pop: -10, influence: 8, money: 150, risk: 22 },
  ]},
  { text: 'Movimentos sociais pedem audiência pública\nsobre orçamento municipal.', options: [
    { label: 'Apoiar e organizar a audiência', pop: 12, influence: 8, money: -25, risk: -5 },
    { label: 'Ignorar e seguir a agenda do vereador', pop: -8, influence: 0, money: 0, risk: 3 },
    { label: 'Infiltrar apoiadores para controlar o debate', pop: 0, influence: 10, money: -40, risk: 12 },
  ]},
  { text: 'O Tribunal de Contas investiga uma licitação\nque seu gabinete acompanhou.', options: [
    { label: 'Colaborar e entregar documentos', pop: 8, influence: -3, money: -15, risk: -20 },
    { label: 'Contratar advogado e se resguardar', pop: 0, influence: 0, money: -60, risk: -8 },
    { label: 'Alterar documentos comprometedores', pop: -5, influence: 3, money: 0, risk: 30 },
  ]},
];

export function buildProductDecisions(cityData) {
  const decisions = [];
  const exp = cityData.topExports || [];
  const imp = cityData.topImports || [];
  const cn = cityData.cityName || 'a cidade';
  const vr = cityData.vereador || 'seu vereador';
  const pt = cityData.vereadorPartido || 'o partido';
  const pop = cityData.populacao || 0;
  const pib = cityData.pib || {};

  if (exp[0]) decisions.push({ text: `Empresários de "${exp[0]}" querem isenção\nfiscal em ${cn}. ${vr} pede sua opinião.`, options: [
    { label: 'Defender isenção com estudo técnico', pop: 5, influence: 10, money: -15, risk: -3 },
    { label: 'Negociar comissão pessoal pela isenção', pop: -5, influence: 8, money: 80, risk: 18 },
    { label: 'Propor audiência pública sobre o tema', pop: 10, influence: 5, money: -10, risk: -5 },
  ]});
  if (exp[1]) decisions.push({ text: `O setor de "${exp[1]}" em ${cn} enfrenta\ncrise. Seu gabinete pode intervir.`, options: [
    { label: 'Propor projeto de apoio ao setor', pop: 10, influence: 8, money: -30, risk: -3 },
    { label: 'Cobrar dos empresários pelo apoio', pop: -8, influence: 12, money: 100, risk: 15 },
    { label: 'Usar a crise para ganhar mídia', pop: 8, influence: 3, money: -5, risk: 5 },
  ]});
  if (imp[0]) decisions.push({ text: `${cn} importa muito "${imp[0]}". Um\nfornecedor oferece exclusividade ao gabinete.`, options: [
    { label: 'Recusar e manter concorrência aberta', pop: 5, influence: 0, money: 0, risk: -8 },
    { label: 'Aceitar em troca de doação futura', pop: -3, influence: 8, money: 70, risk: 15 },
    { label: 'Criar intermediária para receber comissão', pop: -10, influence: 5, money: 150, risk: 25 },
  ]});
  if (cityData.balance < 0) decisions.push({ text: `${cn} tem déficit comercial alto.\n${vr} quer criar programa de incentivo.`, options: [
    { label: 'Elaborar projeto técnico transparente', pop: 10, influence: 8, money: -20, risk: -5 },
    { label: 'Direcionar verba para aliados do partido', pop: -5, influence: 15, money: 40, risk: 12 },
    { label: 'Culpar o governo federal publicamente', pop: 5, influence: 3, money: 0, risk: 3 },
  ]});
  if (cityData.balance > 0 && cityData.exportValue > 0) decisions.push({ text: `${cn} tem superávit comercial.\nHá pressão para usar a receita extra.`, options: [
    { label: 'Propor investimento em educação', pop: 12, influence: 5, money: -15, risk: -5 },
    { label: 'Criar fundo com gestão controlada', pop: -3, influence: 10, money: 50, risk: 12 },
    { label: 'Distribuir benefícios pré-eleição', pop: 8, influence: 5, money: -40, risk: 8 },
  ]});

  if (pib.pibPerCapita && pib.pibPerCapita < 20000) decisions.push({ text: `O PIB per capita de ${cn} é baixo.\n${vr} quer propor um plano de desenvolvimento.`, options: [
    { label: 'Elaborar plano com participação popular', pop: 12, influence: 8, money: -25, risk: -5 },
    { label: 'Priorizar aliados empresariais no plano', pop: -5, influence: 12, money: 60, risk: 12 },
    { label: 'Exigir emendas federais via lobby', pop: 3, influence: 15, money: -40, risk: 8 },
  ]});
  if (pib.pibPerCapita && pib.pibPerCapita > 50000) decisions.push({ text: `${cn} tem PIB per capita alto.\nGrupos econômicos disputam influência na câmara.`, options: [
    { label: 'Manter distância e votar pela cidade', pop: 10, influence: -5, money: 0, risk: -8 },
    { label: 'Mediar entre grupos e ganhar dos dois lados', pop: 0, influence: 15, money: 80, risk: 15 },
    { label: `Priorizar o grupo mais alinhado ao ${pt}`, pop: -5, influence: 10, money: 40, risk: 5 },
  ]});
  if (pib.vabAgro && pib.vabTotal && (pib.vabAgro / pib.vabTotal) > 0.3) decisions.push({ text: `O agronegócio domina a economia de ${cn}.\nRuralistas pedem apoio do gabinete.`, options: [
    { label: 'Apoiar com transparência e fiscalização', pop: 8, influence: 10, money: -15, risk: -5 },
    { label: 'Cobrar participação nos lucros da safra', pop: -5, influence: 5, money: 90, risk: 18 },
    { label: 'Propor reforma agrária no município', pop: 15, influence: -8, money: -20, risk: 10 },
  ]});
  if (pib.vabIndustria && pib.vabTotal && (pib.vabIndustria / pib.vabTotal) > 0.3) decisions.push({ text: `O setor industrial é forte em ${cn}.\nSindicatos e empresários buscam apoio na câmara.`, options: [
    { label: 'Mediar acordo entre sindicato e empresários', pop: 10, influence: 12, money: -20, risk: -5 },
    { label: 'Apoiar empresários em troca de doações', pop: -8, influence: 8, money: 100, risk: 15 },
    { label: 'Apoiar sindicato e conquistar base popular', pop: 15, influence: 5, money: -15, risk: 3 },
  ]});

  if (pop > 500000) decisions.push({ text: `${cn} é uma grande cidade.\nHá demanda por mais transparência nos gastos.`, options: [
    { label: 'Criar portal de transparência digital', pop: 12, influence: 8, money: -50, risk: -10 },
    { label: 'Aprovar sem mudar os processos internos', pop: -3, influence: 5, money: 0, risk: 8 },
    { label: 'Propor auditoria que prejudique adversários', pop: 3, influence: 15, money: -30, risk: 12 },
  ]});
  if (pop < 50000) decisions.push({ text: `Em ${cn}, todo mundo se conhece.\nUm boato sobre você circula pela cidade.`, options: [
    { label: 'Confrontar o boato com fatos publicamente', pop: 8, influence: 5, money: -10, risk: -8 },
    { label: 'Ignorar e focar no trabalho', pop: -3, influence: 0, money: 0, risk: 3 },
    { label: 'Descobrir quem espalhou e retaliar', pop: -5, influence: 8, money: -20, risk: 15 },
  ]});

  decisions.push({ text: `${vr} pede que você organize\numa base de apoio no partido ${pt}.`, options: [
    { label: 'Articular com transparência e mérito', pop: 5, influence: 12, money: -20, risk: -5 },
    { label: 'Usar cargos comissionados como moeda', pop: -8, influence: 15, money: 20, risk: 18 },
    { label: 'Prometer e não cumprir — ganhar tempo', pop: -3, influence: 5, money: 0, risk: 8 },
  ]});
  decisions.push({ text: `${vr} está em dúvida sobre um\nvoto polêmico na câmara. Você aconselha:`, options: [
    { label: 'Votar de acordo com a opinião pública', pop: 12, influence: -3, money: 0, risk: -3 },
    { label: 'Votar com o governo em troca de emendas', pop: -8, influence: 10, money: 60, risk: 10 },
    { label: 'Se abster para não criar inimigos', pop: -3, influence: 3, money: 0, risk: -5 },
  ]});
  decisions.push({ text: `A prestação de contas do gabinete de\n${vr} precisa ser apresentada. O que fazer?`, options: [
    { label: 'Apresentar contas detalhadas e honestas', pop: 8, influence: 3, money: -10, risk: -15 },
    { label: 'Maquiar despesas para parecer eficiente', pop: 3, influence: 5, money: 20, risk: 20 },
    { label: 'Pedir prazo alegando complexidade técnica', pop: -3, influence: 0, money: 0, risk: 5 },
  ]});

  return decisions;
}

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function categorizeDecision(text, isNews) {
  const t = (text || '').toLowerCase();
  if (/export|import|comércio|econom|déficit|superávit|pib/.test(t)) return { icon: '📊', label: 'ECONOMIA' };
  if (/tribunal|licitação|investig|justiça|lei\b/.test(t)) return { icon: '⚖️', label: 'JUSTIÇA' };
  if (/voto|eleição|câmara|partido|vereador/.test(t)) return { icon: '🗳️', label: 'POLÍTICA' };
  if (/corrup|dossiê|propina|desvio|suborno/.test(t)) return { icon: '💰', label: 'CORRUPÇÃO' };
  if (/imprensa|mídia|jornal|rede social/.test(t)) return { icon: '📢', label: 'MÍDIA' };
  if (isNews) return { icon: '📰', label: 'NOTÍCIA' };
  return { icon: '📋', label: 'DECISÃO' };
}

export function buildDecisionDeck(cityData, newsDecisions, maxTurns) {
  const newsDecs = (newsDecisions || []).map(d => ({
    text: (d.text || '').replace(/\\n/g, '\n'),
    options: (d.options || []).map(o => ({
      label: o.label, pop: o.pop || 0, influence: o.influence || 0, money: o.money || 0, risk: o.risk || 0,
    })),
    fromNews: true,
    source: d.source,
  })).filter(d => d.options.length >= 2);

  const dataDecs = buildProductDecisions(cityData || {});
  const generic = shuffle([...GENERIC_DECISIONS]);
  const nSlots = Math.min(newsDecs.length, Math.ceil(maxTurns * 0.6));
  const selNews = shuffle(newsDecs).slice(0, nSlots);
  const fillers = shuffle([...dataDecs, ...generic]).slice(0, maxTurns - selNews.length - 1);

  const vr = cityData?.vereador || 'Seu vereador';
  const cn = cityData?.cityName || 'a cidade';
  const firstDecision = {
    text: `Primeiro dia no gabinete de ${vr}\nem ${cn}. Uma demanda urgente chega à sua mesa.`,
    options: [
      { label: 'Resolver com eficiência e transparência — mostrar competência', pop: 8, influence: 5, money: -10, risk: -5 },
      { label: 'Usar a oportunidade para fazer contatos políticos', pop: 3, influence: 10, money: 5, risk: 3 },
      { label: 'Delegar para outro assessor e observar a dinâmica', pop: 0, influence: 3, money: 0, risk: 0 },
    ],
  };

  return [firstDecision, ...shuffle([...selNews, ...fillers])];
}
